/**
 * @author vishwadeep.kapoor
 * @Date: 2019-01-07 13:07:40
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2021-01-06 12:16:58
 */

import { utils } from '../../devUtils';

export const DEFAULT_ACTION = '/NetworkCards/DEFAULT_ACTION';
export const FETCH_TRANSACTIONS_SUCCESS = '/NetworkCards/FETCH_TANSACTION_SUCCESS';
export const FETCH_CARD_DATA_YSC = '/NetworkCards/FETCH_CARD_DATA_YSC';
export const FETCH_CARD_DATA_YBL = '/NetworkCards/FETCH_CARD_DATA_YBL';
export const FETCH_CARD_DATA_NSDL = '/NetworkCards/FETCH_CARD_DATA_NSDL';
export const SET_CARD_BLOCK_SUCCESS = '/NetworkCards/SET_CARD_BLOCK_SUCCESS';
export const SET_REPORT_SUCCESS = '/NetworkCards/SET_REPORT_SUCCESS';
export const SET_CARD_REMOVE_SUCCESS = '/NetworkCards/SET_CARD_REMOVE_SUCCESS';
export const SET_POS_OTP_SEND_SUCCESS = '/NetworkCards/SET_POS_OTP_SEND_SUCCESS';
export const SET_CARD_PIN_RESET_SUCCESS = '/NetworkCards/SET_CARD_PIN_RESET_SUCCESS';
export const SET_REQUEST_INTERNET_PIN = '/NetworkCards/SET_REQUEST_INTERNET_PIN';
export const SET_REPORT_STATEMENT_SUCCESS = '/NetworkCards/SET_REPORT_STATEMENT_SUCCESS';
export const SET_NSDL_M2P_STATEMENT_SUCCESS = '/NetworkCards/SET_NSDL_M2P_STATEMENT_SUCCESS';
export const SET_NSDL_ISG_STATEMENT_SUCCESS = '/NetworkCards/SET_NSDL_ISG_STATEMENT_SUCCESS';
export const SET_REPORT_SUCCESS_INDUSIND = '/NetworkCards/SET_REPORT_SUCCESS_INDUSIND';
export const SET_YES_BANK_WEARABLE_FAQ_SUCCESS = '/NetworkCards/SET_YES_BANK_WEARABLE_FAQ_SUCCESS';
export const SET_NSDL_M2P_REPLACE_CARD_SUCCESS = '/NetworkCards/SET_NSDL_M2P_REPLACE_CARD_SUCCESS';
export const SET_NSDL_M2P_BLOCK_CARD_SUCCESS = '/NetworkCards/SET_NSDL_M2P_BLOCK_CARD_SUCCESS';
export const WALLET_TO_IMPS_TRANSFER_SUCCESS = '/NetworkCards/WALLET_TO_IMPS_TRANSFER_SUCCESS';
export const SET_IPIN_SUCCESS = '/NetworkCards/SET_IPIN_SUCCESS';
export const RESET_PASSWORD_SUCCESS = '/NetworkCards/RESET_PASSWORD_SUCCESS';
export const SET_IPIN_OTP_SUCCESS = '/NetworkCards/SET_IPIN_OTP_SUCCESS';
export const YBL_DELETE_BENEFICIARY_SUCCESS = '/NetworkCards/YBL_DELETE_BENEFICIARY_SUCCESS';
export const UNLOCK_CARD_OTP_SUCCESS = '/NetworkCards/UNLOCK_CARD_OTP_SUCCESS';
export const FETCH_CARD_DATA_V2 = '/NetworkCards/FETCH_CARD_DATA_V2';
export const GET_OTP_SUCCESS = '/NetworkCards/GET_OTP_SUCCESS';
export const SET_CHANNEL_FLAG_SUCCESS = '/NetworkCards/SET_CHANNEL_FLAG_SUCCESS';

export const DEFAULT_PRE_PAYLOAD = { action_type: 'lock_card' };
export const DEFAULT_PRE_TRANS_PAYLOAD = { page_no: 1, count: 10 };
export const CUSTOMER_CARE_YES_BANK = 'In case of any queries, please call the toll-free number 1800 103 5485 or write to us at';
export const CUSTOMER_CARE_INDUSIND_BANK = 'In case of any queries, please call the toll-free number 1860 500 1231 or write to us at';
export const ZAGGLE_MAIL = 'care@zaggle.in';
export const MAIL_TO = '"mailto:care@zaggle.in"';

const NETWORKCARD_CONSTANTS = Object.freeze({
  SET_COMPLAIN_TYPE_LIST: '/NetworkCards/SET_COMPLAIN_TYPE_LIST',
  SET_COMPLAIN_LIST: '/NetworkCards/SET_COMPLAIN_LIST',
  SET_COMPLAIN_CREATE: '/NetworkCards/SET_COMPLAIN_CREATE',
  SET_BENEFICIARIES_LIST: '/NetworkCards/SET_BENEFICIARIES_LIST',
  SET_BENEFICIARIES_CREATE: '/NetworkCards/SET_BENEFICIARIES_CREATE',
  SET_BENEFICIARIES_CREATE_NEW: '/NetworkCards/SET_BENEFICIARIES_CREATE_NEW',
  SET_BENEFICIARY_VIEW: '/NetworkCards/SET_BENEFICIARY_VIEW',
  SET_TRANSACTION_LIMIT_VIEW: '/NetworkCards/SET_TRANSACTION_LIMIT_VIEW',
  SET_TRANSACTION_LIMIT_UPDATE: '/NetworkCards/SET_TRANSACTION_LIMIT_UPDATE',
  SET_NSDL_BENEFICIARIES_CREATE: '/NetworkCards/SET_NSDL_BENEFICIARIES_CREATE',
  SET_NSDL_BENEFICIARIES_LIST: '/NetworkCards/SET_NSDL_BENEFICIARIES_LIST',
  SET_NSDL_BENEFICIARY_VIEW: '/NetworkCards/SET_NSDL_BENEFICIARY_VIEW',
  SET_NSDL_BENEFICIARIES_UPDATE: '/NetworkCards/SET_NSDL_BENEFICIARIES_UPDATE',
  SET_GENERATE_OTP_NSDL: 'NetworkCards/SET_GENERATE_OTP_NSDL',
  GENERATE_M2P_STATEMENT: 'Generate M2P E-mail Statement',
  GENERATE_ISG_STATEMENT: 'Generate ISG E-mail Statement',
  SET_YBL_VERIFY_LIMIT_OTP: '/NetworkCards/SET_YBL_VERIFY_LIMIT_OTP',
  SET_YBL_OTP_SUCCESS: 'NetworkCards/SET_YBL_OTP_SUCCESS',
  SET_YBL_OTP_VERIFIED: 'NetworkCards/SET_YBL_OTP_VERIFIED',
  VALIDATE_IPIN: 'Please Validate to Set your IPIN.',
  CONTACT_CUSTOMER_CARE: 'Not your number ? Contact customer service',
  YES_BANK_CARD_LOCK: 'yessbank_card_lock',
  YES_BANK_CARD_UNLOCK: 'yessbank_card_unlock',
  YES_BANK_CARD_BLOCK: 'yessbank_card_block',
  YES_BANK_CARD_REPLACEMENT: 'yessbank_card_replacement',
  YES_BANK_DELETE_BENE: 'yessbank_delete_beneficary',
  YES_BANK_IMPS: 'yessbank_imps',
  YES_BANK_DRIVER_SALARY: 'yessbank_driver_salary',
  SET_YES_BANK_TRANSFER: '/NetworkCards/SET_YES_BANK_TRANSFER',
});

const HeaderTable = [{
  title: 'Date & time',
  dataIndex: 'TransactionDate',
  key: 'TransactionDate',
},
{
  title: 'Wallet Type',
  dataIndex: 'wallet_name',
  key: 'wallet_name',
},
{
  title: 'Merchant Name',
  dataIndex: 'MerchantName',
  key: 'MerchantName',
},
{
  title: 'Transaction Amount',
  dataIndex: 'TransAmt',
  key: 'TransAmt',
},
{
  title: 'Transaction Type',
  dataIndex: 'DrCrIndicator',
  key: 'DrCrIndicator',
},
{
  title: 'Transaction Status',
  dataIndex: 'TransStatus',
  key: 'TransStatus',
},
{
  title: 'Remarks',
  dataIndex: 'ResponseReason',
  key: 'ResponseReason',
}];

const HeaderTable1 = [{
  title: 'Date & time',
  dataIndex: 'TransactionDate',
  key: 'TransactionDate',
}, {
  title: 'Merchant Name',
  dataIndex: 'MerchantName',
  key: 'MerchantName',
}, {
  title: 'Transaction Amount',
  dataIndex: 'TransAmt',
  key: 'TransAmt',
}, {
  title: 'Transaction Type',
  dataIndex: 'DrCrIndicator',
  key: 'DrCrIndicator',
}, {
  title: 'Transaction Status',
  dataIndex: 'TransStatus',
  key: 'TransStatus',
}, {
  title: 'Remarks',
  dataIndex: 'ResponseReason',
  key: 'ResponseReason',
},
// {
//   title: 'Reference bill',
//   dataIndex: 'reference',
// }
];

/**
 * @todo need to write the middle layer for this as this is called by the render :(
 */
export const updateObjectKeyValues = (array) => {
  const values = array && array.map((item) => {
    const _item = item;
    _item.DrCrIndicator = _item.DrCrIndicator === 'C' ? 'Credit' : 'Debit';
    _item.transaction_time = _item.reference_no || _item.TransRefNo;
    return _item;
  });
  return values;
};

export const CALCULATE_BALANCE = (cardData, id) => {
  const {
    cards: [
      {
        Details = [],
        card_type = '',
        amount = '',
      } = {},
    ] = [],
  } = cardData;
  if (['Virtual', 'Physical'].includes(card_type) && ['physical', 'virtual'].includes(id)) {
    return amount;
  } else if (cardData.ProductInfo) {
    if (cardData.multipurpose_card === true) {
      let temp = 0;
      Details.forEach((item) => {
        temp += parseFloat(item.Amount);
      });
      return utils.roundNumber(temp);
    }
    return Details.Amount;
  }
  return '- -';
};

export const CALCULATE_BALANCE_YSC = (cardData) => {
  const {
    card_info: {
      ProductInfo = {},
      ProductInfo: {
        Details = [],
      } = {},
    } = {},
  } = cardData;
  if (ProductInfo) {
    if (Details && Details.length > 0) {
      let temp = 0;
      Details.forEach(({ Amount }) => {
        temp += parseFloat(Amount);
      });
      return utils.roundNumber(temp);
    }
  }
  return '- -';
};

export const CALCULATE_BALANCE_YESBANK = (cardData) => {
  const {
    cards: [
      {
        Details = [],
        amount = '',
      } = {},
    ] = [],
  } = (cardData && cardData[0]) || {};
  if (amount || amount.toString() === '0') {
    return amount;
  }
  if (Details && Details.length) {
    let temp = 0;
    Details.forEach(({ Amount }) => {
      temp += parseFloat(Amount);
    });
    return utils.roundNumber(temp);
  }
  return '- -';
};

export const CALCULATE_BALANCE_NSDL = (cardData, id) => {
  const {
    ProductInfo = {},
    multipurpose_card = false,
    ProductInfo:
    {
      Details = {},
      Details:
      {
        Amount = '',
      } = {},
    } = {},
    card_type = {},
    amount = {},
  } = cardData;
  if (['Virtual', 'Physical'].includes(card_type) && ['Physical', 'Virtual'].includes(id)) {
    return amount;
  } else if (ProductInfo) {
    if (multipurpose_card) {
      let temp = 0;
      Details.forEach(({ Amount: deatailsAmount }) => {
        temp += parseFloat(deatailsAmount);
      });
      return utils.roundNumber(temp);
    }
    return Amount;
  }
  return '- -';
};


const GetActiveCardDetails = (response, cardType) => {
  const { Details,
    name,
    code,
    amount,
    transaction_type,
    card_status,
    ...restData
  } = utils.lodashFind(response.cards, { card_type: cardType.charAt(0).toUpperCase() + cardType.slice(1) }) || {};
  return {
    status: response.status,
    CardStatus: card_status,
    ProxyNumber: code,
    message: response.message,
    ProductInfo: { Details: Details && Details.length ? Details : { Amount: amount } },
    multipurpose_card: !!(Details && Details.length),
    card_name: name,
    amount,
    isEcomEnabled: !!utils.lodashFind(transaction_type, { name: 'ECOM', status: true }).name,
    isPosEnabled: !!utils.lodashFind(transaction_type, { name: 'POS', status: true }).name,
    isAtmEnabled: !!utils.lodashFind(transaction_type, { name: 'ATM', status: true }).name,
    ts: Date.now(),
    ...restData,
  };
};

const GetCustomAlert = (payload, response) => {
  const { channel_name, channel_flag, action_type } = payload;
  switch (channel_name) {
    case 'ECOM':
    case 'POS':
    case 'ATM':
      return `${channel_name} transactions ${channel_flag.toLowerCase()}d successfully`;
    default:
      switch (action_type) {
        case 'lock':
        case 'unlock':
        case 'block':
          return `Card ${action_type}ed successfully`;
        case 'replace':
          return response.message;
        case 'generate_otp':
          return 'Otp Generated Successfully';
        default:
          break;
      }
      break;
  }
  return '';
};

const today = utils.momentInstance();
const ninetyDaysAgo = utils.momentInstance().subtract(90, 'days');

export { HeaderTable, HeaderTable1, GetActiveCardDetails, GetCustomAlert, NETWORKCARD_CONSTANTS, today, ninetyDaysAgo };



// WEBPACK FOOTER //
// client/containers/NetworkCards/constants.js